export default __webpack_public_path__ + "static/media/home.486450d1.jpg";